{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mfrs_2022-12-31/ssmt-fs-mfrs_2022-12-31_role-130000",
  "definition": "[130000] Disclosure - Auditors report to members",
  "sheetId": "AuditorsReport",
  "label": "Auditors Report",
  "controls": [
    {
      "qname": "ssmt:DisclosureOfAuditorsReportToMembersExplanatory",
      "label": "Disclosure of auditor's report to members",
      "type": "xbrli:stringItemType",
      "ui": {
        "control": "richtext",
        "rows": 15
      },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "When \"Disclosure of financial statements audit status\" is \"Audited\", then \"Disclosure of auditor's report to members (text block)\" is MANDATORY to be reported."
      }
    },
    {
      "qname": "ssmt:TypeOfAuditorsOpinion",
      "label": "Type of auditor's opinion",
      "type": "xbrli:stringItemType",
      "ui": {
        "control": "select",
        "enumSource": "type:TypeOfAuditorsOpinion"
      },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "When \"Disclosure of financial statements audit status\" is \"Audited\", then \"Type of auditor's opinion\" MUST be reported."
      }
    },
    {
      "qname": "ssmt:DateOfSigningAuditorsReport",
      "label": "Date of signing auditor's report",
      "type": "xbrli:dateItemType",
      "ui": {
        "control": "date",
        "placeholder": "Select a date"
      },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "When \"Disclosure of financial statements audit status\" is \"Audited\", then \"Date of signing auditor's report\" MUST be reported."
      },
      "warnings": [
        {
          "id": "auditors-report-date-before-year-end",
          "severity": "warning",
          "showInEditedModeOnly": false,
          "condition": {
            "type": "dateComparison",
            "message": "When \"Disclosure of financial statements audit status\" is \"Audited\", then \"Date of signing auditor's report\" must be greater than \"Company's current financial year end date\".",
            "comparisonOperator": "lte",
            "compareWith": {
              "sheet": "filingPrerequisites",
              "field": "ssmt-dei:CompanyCurrentFinancialYearEndDate"
            }
          }
        },
        {
          "id": "auditors-report-date-after-directors-report-date",
          "severity": "warning",
          "showInEditedModeOnly": false,
          "condition": {
            "type": "dateComparison",
            "message": "When \"Disclosure of financial statements audit status\" is \"Audited\", then \"Date of signing director's report\" must be greater than or equal to \"Date of signing auditor's report\"",
            "comparisonOperator": "gt",
            "compareWith": {
              "sheet": "directorsReport",
              "field": "ssmt:DateOfSigningDirectorsReport"
            },
            "conditionalOn": {
              "sheet": "filingPrerequisites",
              "field": "ssmt-dei:DisclosureOfFinancialStatementsAuditStatus",
              "equals": "Audited"
            }
          }
        }
      ]
    },
    {
      "qname": "ssmt:LicenseNumberOfAuditor",
      "label": "License number of auditor",
      "type": "xbrli:stringItemType",
      "ui": {
        "control": "text",
        "auditorTable": true,
        "auditorRow": "licenseNumber",
        "auditorColumns": ["0001"],
        "maxLength": 4,
        "inputFilter": "numeric"
      },
      "required": true,
      "validators": [
        { "name": "required" },
        { "name": "pattern", "pattern": "^\\d{4}$" },
        { "name": "maxLength", "value": 4 }
      ],
      "error": {
        "required": "This is a mandatory field.",
        "pattern": "Please input the first 4 digit from the auditor's full license number. E.g. <u>XXXX</u>/XX/XX(J/PH)",
        "maxlength": "License number must not exceed 4 characters."
      }
    },
    {
      "qname": "ssmt:NameOfAuditorSigningReport",
      "label": "Name of auditor signing report",
      "type": "xbrli:stringItemType",
      "ui": {
        "control": "text",
        "auditorTable": true,
        "auditorRow": "auditorName",
        "auditorColumns": ["0001"],
        "maxLength": 255
      },
      "required": true,
      "validators": [{ "name": "required" }, { "name": "maxLength", "value": 255 }],
      "error": {
        "required": "This is a mandatory field.",
        "maxlength": "Name must not exceed 255 characters."
      }
    },
    {
      "qname": "ssmt:RegistrationNumberOfAuditFirm",
      "label": "Registration number of audit firm",
      "type": "xbrli:stringItemType",
      "ui": {
        "control": "text",
        "auditorTable": true,
        "auditorRow": "firmRegistrationNumber",
        "auditorColumns": ["0001"],
        "maxLength": 8,
        "inputTransform": ["stripWhitespace", "uppercase"]
      },
      "required": true,
      "validators": [
        { "name": "required" },
        { "name": "pattern", "pattern": "^AF(?:0\\d{3}|1[0-7]\\d{2}|00(?:1[89]\\d{2}|[2-9]\\d{3}))$" },
        { "name": "maxLength", "value": 8 }
      ],
      "error": {
        "required": "This is a mandatory field.",
        "pattern": "Kindly report a valid Audit firm number: \"AF\" followed by 4 digits (e.g. AF1621), or \"AF00\" followed by 4 digits for firms numbered between 1800 to 9999 (e.g. AF001800).",
        "maxlength": "Registration number of audit firm must not exceed 8 characters."
      }
    },
    {
      "qname": "ssmt:NameOfAuditFirm",
      "label": "Name of audit firm",
      "type": "xbrli:stringItemType",
      "ui": {
        "control": "text",
        "auditorTable": true,
        "auditorRow": "firmName",
        "auditorColumns": ["0001"],
        "maxLength": 255
      },
      "required": true,
      "validators": [{ "name": "required" }, { "name": "maxLength", "value": 255 }],
      "error": {
        "required": "This is a mandatory field.",
        "maxlength": "Name must not exceed 255 characters."
      }
    },
    {
      "qname": "ssmt:AddressOne",
      "label": "Address line 1",
      "type": "xbrli:stringItemType",
      "ui": {
        "control": "text",
        "auditorTable": true,
        "auditorRow": "addressLine1",
        "auditorColumns": ["0001"],
        "maxLength": 255
      },
      "required": true,
      "validators": [{ "name": "required" }, { "name": "maxLength", "value": 255 }],
      "error": {
        "required": "This is a mandatory field.",
        "maxlength": "Name must not exceed 255 characters."
      }
    },
    {
      "qname": "ssmt:AddressTwo",
      "label": "Address line 2",
      "type": "xbrli:stringItemType",
      "ui": {
        "control": "text",
        "auditorTable": true,
        "auditorRow": "addressLine2",
        "auditorColumns": ["0001"],
        "maxLength": 255
      },
      "required": false,
      "validators": [{ "name": "maxLength", "value": 255 }],
      "error": {
        "maxlength": "Name must not exceed 255 characters."
      }
    },
    {
      "qname": "ssmt:AddressThree",
      "label": "Address line 3",
      "type": "xbrli:stringItemType",
      "ui": {
        "control": "text",
        "auditorTable": true,
        "auditorRow": "addressLine3",
        "auditorColumns": ["0001"],
        "maxLength": 255
      },
      "required": false,
      "validators": [{ "name": "maxLength", "value": 255 }],
      "error": {
        "maxlength": "Name must not exceed 255 characters."
      }
    },
    {
      "qname": "ssmt:PostcodeOfAuditFirm",
      "label": "Postcode",
      "type": "xbrli:stringItemType",
      "ui": {
        "control": "text",
        "auditorTable": true,
        "auditorRow": "postcode",
        "auditorColumns": ["0001"],
        "maxLength": 255
      },
      "required": true,
      "validators": [{ "name": "required" }, { "name": "maxLength", "value": 255 }],
      "error": {
        "required": "This is a mandatory field.",
        "maxlength": "Name must not exceed 255 characters."
      }
    },
    {
      "qname": "ssmt:TownWhereAuditFirmIsLocated",
      "label": "Town",
      "type": "xbrli:stringItemType",
      "ui": {
        "control": "text",
        "auditorTable": true,
        "auditorRow": "town",
        "auditorColumns": ["0001"],
        "maxLength": 255
      },
      "required": true,
      "validators": [{ "name": "required" }, { "name": "maxLength", "value": 255 }],
      "error": {
        "required": "This is a mandatory field.",
        "maxlength": "Name must not exceed 255 characters."
      }
    },
    {
      "qname": "ssmt:StateWhereAuditFirmIsLocated",
      "label": "State",
      "type": "TypeOfMalaysianState",
      "ui": {
        "control": "select",
        "placeholder": "Select state",
        "enumSource": "type:TypeOfMalaysianState",
        "auditorTable": true,
        "auditorRow": "state",
        "auditorColumns": ["0001"]
      },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      }
    },
    {
      "qname": "ssmt:DisclosureOfWhetherAuditorsReportContainsKeyAuditMatters",
      "label": "Does the auditor's report contain Key Audit Matters (KAM)?",
      "type": "xbrli:stringItemType",
      "ui": {
        "control": "select",
        "placeholder": "Select Yes or No",
        "enumSource": "type:YesNoItemType"
      },
      "required": false,
      "conditional": {
        "controlledBy": { "sheet": "filingInfo", "field": "ssmt-dei:TypeOfSubmission" },
        "inactiveWhenValueIn": ["FS-MPERS", "FS-MFRS"],
        "appliesTo": "both"
      }
    },
    {
      "qname": "ssmt:DisclosureOfKeyAuditMatters",
      "label": "Description of Key Audit Matters",
      "type": "xbrli:stringItemType",
      "ui": {
        "control": "textarea",
        "placeholder": "Describe the key audit matters identified...",
        "rows": 8
      },
      "required": false,
      "conditional": {
        "controlledBy": "ssmt:DisclosureOfWhetherAuditorsReportContainsKeyAuditMatters",
        "activeWhenValueIn": ["Yes"],
        "appliesTo": "both"
      }
    },
    {
      "qname": "ssmt:DisclosureOfWhetherAuditorsReportContainsMaterialUncertaintyRelatedToGoingConcern",
      "label": "Does the auditor's report contain material uncertainty related to going concern?",
      "type": "xbrli:stringItemType",
      "ui": {
        "control": "select",
        "placeholder": "Select Yes or No",
        "enumSource": "type:YesNoItemType"
      },
      "required": false,
      "conditional": {
        "controlledBy": { "sheet": "filingInfo", "field": "ssmt-dei:TypeOfSubmission" },
        "inactiveWhenValueIn": ["FS-MPERS", "FS-MFRS"],
        "appliesTo": "both"
      }
    },
    {
      "qname": "ssmt:DisclosureOfMaterialUncertaintyRelatedToGoingConcern",
      "label": "Description of Material Uncertainty Related to Going Concern",
      "type": "xbrli:stringItemType",
      "ui": {
        "control": "textarea",
        "placeholder": "Describe the material uncertainty related to going concern...",
        "rows": 6
      },
      "required": false,
      "conditional": {
        "controlledBy": "ssmt:DisclosureOfWhetherAuditorsReportContainsMaterialUncertaintyRelatedToGoingConcern",
        "activeWhenValueIn": ["Yes"],
        "appliesTo": "both"
      }
    },
    {
      "qname": "ssmt:PlaceOfAuditorsReport",
      "label": "Place of Auditor's Report",
      "type": "xbrli:stringItemType",
      "ui": {
        "control": "text",
        "placeholder": "Enter city/state (e.g., Kuala Lumpur)",
        "maxLength": 255
      },
      "required": false,
      "error": {
        "maxlength": "Place must not exceed 255 characters."
      },
      "conditional": {
        "controlledBy": { "sheet": "filingInfo", "field": "ssmt-dei:TypeOfSubmission" },
        "inactiveWhenValueIn": ["FS-MPERS", "FS-MFRS"],
        "appliesTo": "both"
      }
    }
  ]
}
